<template>
  <div class="search">
    <div class="container">
      <div style="height: 50px"></div>
      <div class="article-items flex">
        <List :listData="listData" />
      </div>
      <div class="tip-box flex">
        <el-divider v-show="loading && !isOver"><el-button :loading="true">加载中</el-button></el-divider>
        <el-divider v-show="!loading && !isOver"><el-button size="small" @click="getList()">加载更多</el-button></el-divider>
        <el-divider v-show="!loading && isOver">已全部加载</el-divider>
      </div>
      <div style="height: 100px"></div>
    </div>
    
  </div>
</template>

<script>
import { api } from "@/api"
import { reactive, toRefs } from "vue"
import { useRoute } from "vue-router"
import List from "@/components/common/List.vue"
export default {
  name: "search",
  components: {List},
  setup() {
    const route = useRoute()
    let initData = reactive({
      loading: false,
      isOver: false,
      page: 1,
      listData: [],
    })
    getList()
    function getList() {
      initData.loading = true
      api("post", "newSearchV2", {keyword: route.query.key, pageNum: initData.page, pageSize: 12})
        .then(res => {
          initData.loading = false
          if(res.code === 1200) {
            if(res.data) { // 数据存  处理后台返回 null
              if(initData.page == 1) { // 处理掉loading数据
                initData.listData = res.data
              } else {
                initData.listData = [ ...initData.listData, ...res.data]
              }
              // 加载完成
              if(res.data.length < 12) {
                initData.isOver = true
           
              } else {
                initData.page += 1
              }
            } else {
              initData.isOver = true
       
            }
          } else {
            initData.isOver = true
           
          }
        })
        .catch(err => {
          initData.isOver = true
          initData.loading = false

        })
    }
    return {
      ...toRefs(initData),
      getList
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  min-height: calc(100vh - 80px);
  background-color: #F6F6F6;
  .container {
    width: 1220px;
  }
}
.article-items {
  flex-wrap: wrap;
  :deep(.article-box) {
    margin: 10px 10px;
  }

}
.tip-box {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  
}
:deep(.el-divider__text) {
  background-color: #F6F6F6;
  color: #585858;
}
</style>